import type { PortfolioListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

type PortfolioTileLabel = {
	title: string;
	subtitle: string | null;
};

const trimToNull = (value: string | null | undefined): string | null =>
	value?.trim() || null;

export const getPortfolioTileLabel = (
	data: Pick<
		PortfolioListItemResponseDTO,
		"name" | "product" | "producer" | "domain"
	>,
	t: TranslateFunction,
): PortfolioTileLabel => {
	const title = trimToNull(data.name) ?? trimToNull(data.product);
	const producer = trimToNull(data.producer);

	if (title) {
		return { title, subtitle: producer };
	}
	if (producer) {
		return { title: producer, subtitle: null };
	}
	return {
		title: data.domain
			? t(Resources.Portfolio.List.PortfolioDomainType[data.domain])
			: "",
		subtitle: null,
	};
};
